"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const redux_observable_1 = require("redux-observable");
const typescript_fsa_1 = __importDefault(require("typescript-fsa"));
const reducerWithImmer_1 = require("./reducerWithImmer");
exports.initialState = {
    selected: 1,
    /**
     * [stage1, stage2, ...]
     */
    stages: [],
    mine: [],
    ours: []
};
const actionCreator = typescript_fsa_1.default('gamebook');
exports.actions = {
    setFloor: actionCreator('SET_FLOOR'),
    setStages: actionCreator('SET_STAGES'),
    setMine: actionCreator('SET_MINE'),
    setOurs: actionCreator('SET_OURS')
};
const floor = reducerWithImmer_1.reducerWithImmer(exports.initialState)
    .case(exports.actions.setFloor, (draft, payload) => {
    draft.selected = payload;
})
    .case(exports.actions.setStages, (draft, payload) => {
    draft.stages = payload;
})
    .case(exports.actions.setMine, (draft, payload) => {
    draft.mine = payload;
})
    .case(exports.actions.setOurs, (draft, payload) => {
    draft.ours = payload;
})
    .toReducer();
exports.default = floor;
exports.reducers = {
    floor
};
exports.epic = redux_observable_1.combineEpics();
